export const ILLNESS = {
  isHidden: true,
  nickname: 'PRODUCTS.ILLNESS.nickname',
  lifeInsurance: true,
  icon:'illness'
};
